export { default as FolderMaterialSolidIcon } from './FolderMaterialSolidIcon';
